// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Testimonial_avatar__3KbGq","ResturantName":"Testimonial_ResturantName__F2FkW"};